import { JWayIcon } from "../../../common/assets/JWayIcons";
import { ConnectorType } from "../types/stations.types";

export const JWayIconConnectorConverter = (connectorType: ConnectorType | null, size: number, color: string, style?:React.CSSProperties | undefined ) => {
  switch (connectorType) {
    case 'CCS2': 
      return <div style={style}><JWayIcon type={"car-plug-ccs2"} size={size} color={color} /></div>;
    case 'GB/T':
      return <div style={style}><JWayIcon type={"car-plug-type-2"} size={size} color={color} /></div>;
    case 'Type2':
      return <div style={style}><JWayIcon type={"car-plug-type-2"} size={size} color={color} /></div>;
    case 'E/F':
      return <div style={style}><JWayIcon type={"ef-plug"} size={size} color={color} /></div>;
    default:
      return <div style={style}><JWayIcon type={"car-plug-type-2"} size={size} color={color} /></div>;
  }
}